import React from 'react';

import Layout from 'layouts/Layout';
import SettingsPreorder from './SettingsPreorder';

const SettingsPreorderLayout = ({ match }) => <Layout component={SettingsPreorder} match={match} />;

export default SettingsPreorderLayout;
